import React from 'react'

import GenericMessagePage from '@/components/organisms/GenericMessagePage'
import { Colors } from '@/utils'
import Attention from '@interco/icons/build-v4/orangeds/MD/attention'
import Canceled from '@interco/icons/build-v4/orangeds/MD/canceled'
import Pending from '@interco/icons/build-v4/orangeds/MD/pending'

type Variant = 'warning' | 'error' | 'pending'
type Layout = {
  icon: JSX.Element
  iconWrapperColor: string
}

type Props = {
  variant: Variant
  title: string
  description?: string
  footer: JSX.Element | JSX.Element[]
}

const getLayout = (variant: Variant): Layout => {
  switch (variant) {
    case 'warning':
      return {
        icon: <Attention height={32} width={32} color={Colors.WHITE} />,
        iconWrapperColor: Colors.ALERT500,
      }
    case 'error':
      return {
        icon: <Canceled height={32} width={32} color={Colors.WHITE} />,
        iconWrapperColor: Colors.ERROR500,
      }
    case 'pending':
      return {
        icon: <Pending height={32} width={32} color={Colors.WHITE} />,
        iconWrapperColor: Colors.ALERT500,
      }
    default:
      throw new Error(`Invalid variant: ${variant}`)
  }
}

const WarningPage = ({ variant, title, description, footer }: Props) => {
  const layout = getLayout(variant)

  return (
    <GenericMessagePage
      icon={layout.icon}
      iconWrapperColor={layout.iconWrapperColor}
      footer={footer}
      title={title}
      description={description}
    />
  )
}

export default WarningPage
